import { Pressable, Typography } from '@rbilabs/universal-components';
import { GestureResponderEvent, StyleSheet } from 'react-native';

import { primitive } from 'styles/constants';
import {
  HapticsImpactStyle,
  HapticsNotificationType,
  hapticImpact,
  hapticNotification,
} from 'utils/haptic';

import { IRadioCheckListOption } from '../types';

import { AddIcon } from './icons/add-icon';
import { RemoveICon } from './icons/remove-icon';
import { TrashIcon } from './icons/trash-icon';

interface IProductOptions {
  selection: any;
  options: IRadioCheckListOption[];
  onOptionPress: any;
  isSelected: boolean;
  multipleChoiceQuantity?: boolean;
}

export const ProductOptions = ({
  isSelected,
  selection,
  options,
  onOptionPress,
  multipleChoiceQuantity = false,
}: IProductOptions) => {
  const currentIndex = options.findIndex(option => option.value === selection);

  const currentOption = options[currentIndex];
  const prevOption = options[currentIndex - 1];
  const nextOption = options[currentIndex + 1];

  const isFirst = currentIndex <= 0;
  const isLast = currentIndex === options.length - 1;
  const isPrevFirst = (currentIndex - 1 === 0 && prevOption.multiplier === 0) || !prevOption;

  const handleDecrease = (e: GestureResponderEvent) => {
    e.stopPropagation();

    if (isFirst && !multipleChoiceQuantity) {
      return;
    }

    const newOption = options[currentIndex - 1];
    const newOptionValue = newOption ? newOption.value : 0;
    const newOptionMultiplier = newOption ? newOption.multiplier : 0;

    onOptionPress(newOptionValue);

    if (newOptionMultiplier === 0) {
      return hapticNotification({ type: HapticsNotificationType.WARNING });
    }
    return hapticImpact({ style: HapticsImpactStyle.Light });
  };

  const handleIncrease = (e: GestureResponderEvent) => {
    e.stopPropagation();

    if (isLast) {
      return;
    }

    const newOption = options[currentIndex + 1];
    onOptionPress(newOption?.value);

    hapticImpact({ style: HapticsImpactStyle.Light });
  };

  if (!isSelected || currentIndex === -1) {
    return null;
  }

  const label = currentOption?.label ?? '';
  const trashIconDisabled = !prevOption && !multipleChoiceQuantity;

  return (
    <Pressable
      testID="product-card-controls"
      style={styles.container}
      onStartShouldSetResponder={() => true}
      onPress={(e: GestureResponderEvent) => e.stopPropagation()}
    >
      <Pressable onPress={handleDecrease} disabled={trashIconDisabled}>
        {isPrevFirst ? (
          <TrashIcon fill={trashIconDisabled ? primitive.$blackOpacity30 : primitive.$bbqBrown} />
        ) : (
          <RemoveICon />
        )}
      </Pressable>

      <Typography>{label}</Typography>

      <Pressable onPress={handleIncrease} disabled={!nextOption}>
        <AddIcon fill={!nextOption ? primitive.$blackOpacity30 : primitive.$bbqBrown} />
      </Pressable>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 35,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
});
